import React from 'react';
import { Fragment } from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer';
import Itens from '../../components/itens';
import Head from '../../components/head';


function HomeScreen () {
    return (
        <Fragment>
            <Head titulo="Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Itens />
            <Footer />
        </Fragment>
    );
}

export default HomeScreen;